import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const TEXT_SOURCE_STYLING_PLUGIN_ID = 'source' as const;

export type TextSourceStylingPluginID = typeof TEXT_SOURCE_STYLING_PLUGIN_ID;

export type TextSourceStylingPluginElement = EditorElement;

export type TextSourceStylingPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
  }
>;

export type TextSourceStylingPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    TextSourceStylingPluginOptions & {
      pluginID: TextSourceStylingPluginID;
      component: ComponentType<any>;
      pluginName: string;
    }
>;
